<div class="button-image-container">
    <button class="button-image-text" [disabled]="selected" [ngClass]="selected ? 'selected-answer-image-button': ''" (click)="sendOptions(answer.name)">
      {{ answer.name }}
    </button>
    <button class="button-image-image" [disabled]="selected" [ngClass]="selected ? 'selected-answer-image-button': ''" (click)="showImage(answer.key,answer.imageCategory)">
      <span class="material-symbols-outlined">
        image
    </span>
    </button>
</div>

<app-page-loader [text]="'Loading images...'" [loading]="loadingImage"></app-page-loader>